import { render } from "./HeaderLayout.vue?vue&type=template&id=6cc0894b&scoped=true&ts=true"
import script from "./HeaderLayout.vue?vue&type=script&lang=ts"
export * from "./HeaderLayout.vue?vue&type=script&lang=ts"

import "./HeaderLayout.vue?vue&type=style&index=0&id=6cc0894b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc0894b"]])

export default __exports__